const h = {
  name: "SanMarino",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.5,0h3L24,4.7V11h-2v2h2v4.4l-1,1V24h-2v-3H2v3H0V12.8L2.5,9h2.1L7,12.8V19h2v-2h2v2h2v-2h2v2h2v-2h2v2h2
			v-1.4l1-1V15h-8v-2h2v-2h-2V4.7L17.5,0z M5,19v-5.6l-1.5-2.3L2,13.4V19H5z M20,11h-2v2h2V11z M22,6h-6v3h6V6z M21,4l-1.5-2h-1
			L17,4H21z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as SanMarino
};
